<template>
    <div class="manageDiffer"   @click="removeAll($event)" >
        <div id="header" style="margin-bottom: 37px;font-size:14px; width:100%;height: 96px;border: 1px solid #ECECEC ;display: flex;justify-content: space-between;padding: 38px 24px">
          <div style="    display: flex; justify-content: start;">
            <div class="differDate" style="">
                <label >差异标记日期：</label>
                <el-date-picker
                        v-model="deviceFormData.time"
                        type="daterange"
                        size="mini"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :clearable="false"
                        class="list"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                >
                </el-date-picker><!--:picker-options="pickerOptions"-->
            </div>
            <div class="differNum" >
                <select class="list" id="numListDiffer" v-model="numList">
                    <option v-for="list in differNum" :key="list.value" :value="list.value"  >{{list.name}}</option>
                </select>

                <div v-if="hideNum"   @click.stop="showNumBox" ><!--v-if="hideNum"-->
                    <el-input

                            style="height: 32px; width:328px;"
                            placeholder="支持10个以内的批量搜索，需用英文逗号隔开"
                            v-model="searchNums.mainContent"
                            @click.native="showArea"
                            @input="inputShowArea"

                    >
                    </el-input>
                </div>
                <div   style="z-index: 9" v-show="secondBox" ><!--v-else-->

                    <el-input class="hideNum" id="secondBox" type="textarea"  @blur="getSecondVal()"  ref="blurLevea"  @keypress.native="delStrim"  resize="none"    :autosize="{ minRows: 3, maxRows: 10 }"     placeholder="支持10个以内的批量搜索，需用英文逗号隔开" v-model="searchNum.content" style=" width:328px; white-space:pre-line">

                    </el-input>
                    <div class="batchSearch">
                       <!-- <el-button
                                style="position: relative; top: -40px;right: -130px;"
                                @click.stop="searchs('搜索')"
                                size="small"
                                type="primary"
                                plain
                        >搜索</el-button>-->
                    </div>
                </div>



            </div>
            <div class="differStatus">
                <label style="margin-left: 32px">标记状态：</label>
                <select class="list" id="statusList" v-model="statusList">
                    <option v-for="list in differStatus" :key="list.value" :value="list.value">{{list.name}}</option>
                </select>
            </div>
            </div>
                <div class="el-buttons">
                    <label  @click="firstGetDiffer" style="margin-right: 24px;color: #008cff;cursor: pointer">清空筛选</label>
                    <el-button @click="firstSelectByCon()" type="primary" style="margin-right: 24px;padding-bottom: 20px">筛选</el-button>
                </div>
            </div>



        <div class="tableTiele" style="    text-align: left; padding: 10px 0 0 20px;      font-size: 14px;font-weight: 600; color: #008cff;    cursor: pointer;width: 108px">
            <div class="setup"  @click.stop="titShow">列表字段筛选</div>
            <div ref="checkPiker"
                    class="titName"
                    v-show="tableShow"
                    @click.stop="tableShow = true"
            >
                <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                >全选</el-checkbox
                >
                <el-checkbox-group
                        v-model="checkedCities"
                        @change="handleCheckedCitiesChange"

                >
                    <el-checkbox
                            v-for="city in cities"
                            :label="city"
                            :key="city"
                            :disabled="checkedCitiesDisable.includes(city)"
                    >{{ city }}</el-checkbox
                    >
                </el-checkbox-group>
            </div>
        </div>
        <div id="content"  >
            <el-table :data="tableData"   :max-height="TableMaxHeight"  :max-width="TableMaxWidth"  >
             <!--  <el-table-column label="序号" align="center" width="48" >
                    <template slot-scope="scope">
                        &lt;!&ndash; 这里暂时写为 默认 index值, 需要后期与接口联动 , <当前页> 和 <x条/页> &ndash;&gt;
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>-->
                <el-table-column
                        align="left"
                        prop="createTime"
                        label="上报日期"
                        width="189"
                        v-if="columnTitle.includes('上报日期')"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="diffBillNo"
                        label="差异编号"
                        width="189"
                        v-if="columnTitle.includes('差异编号')"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="createUserName"
                        label="上报人"
                        width="100"
                        v-if="columnTitle.includes('上报人')"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="statBillNo"
                        label="对账单号"
                        width="189"
                        v-if="columnTitle.includes('对账单号')"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="sourceBillNo"
                        label="运单号"
                        width="189"
                        v-if="columnTitle.includes('运单号')"
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="diffType"
                        label="差异类型"
                        width="189"
                        v-if="columnTitle.includes('差异类型')"
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="diffDescription"
                        label="差异说明"
                        width="189"
                        v-if="columnTitle.includes('差异说明')"
                >
                </el-table-column>
                <el-table-column
                        id="status"
                        align="left"
                        prop="diffStatus"
                        label="处理状态"
                        width="100"
                        v-if="columnTitle.includes('处理状态')"
                >
                    <template slot-scope="scope">
                        <span  class="statusCss">{{scope.row.diffStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="modifyTime"
                        label="处理时间"
                        width="189"
                        v-if="columnTitle.includes('处理时间')"
                >
                </el-table-column>
                <el-table-column
                        align="left"
                        prop="currentHandlerName"
                        label="处理人"
                        width="189"
                        v-if="columnTitle.includes('处理人')"
                >

            </el-table-column>
                <el-table-column
                        align="left"
                    prop="finishDescription"
                    label="处理说明"
                    width="189"
                    v-if="columnTitle.includes('处理说明')"
            >
            </el-table-column>
                <el-table-column fixed="right" label="操作"  align="center"  width="184"  prop="amount">
                    <template slot-scope="scope">
                        <div class="df" style="justify-content:center;">
                            <el-button
                                       @click="selectBy(scope.row )"
                                       type="text"
                                       size="small"
                                       style="margin-right: 36px"
                            >  {{ scope.row.diffStatus }}</el-button>

                            <el-popover trigger="hover"  placement="top" >
                                <span>{{phoneNumDiffer}}</span>
                                <el-button @mouseenter.native="showNum(scope.row.diffBillNo)" slot="reference" type="text" size="small">联系处理人</el-button>
                            </el-popover>
                       </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>


         <div id="bottom" >
             <el-pagination
                     v-if="totalNumber > 10"
                     background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50]"
                     :page-size="pagesize"
                     layout="total,prev, pager, next, sizes,jumper"
                     :total="totalNumber"
             >
             </el-pagination>
         </div>

        <div id="dialog">

            <!--查看差异-->
            <el-dialog id="selectDiffer"  :title="differTitle"  :visible.sync="selectDiffer"  @close="closeDialogAddgsVisible()" width="540px" >
                <div  style="display: flex;flex-direction: row">
                    <ul id="selectNumList">
                        <li :key="item.differTitle" v-for="item in selectAllMessages" >
                            <span class="differTitle">{{item.differTitle}}</span>
                            <el-popover trigger="hover" v-if="item.color===1" placement="right" >
                                <span>{{phoneNumDiffer}}</span>
                                <span :class="item.color===1?'blue':'black'" slot="reference" class="differValue">{{item.value}}</span>
                            </el-popover>
                            <span v-else :class="item.color===1?'blue':'black'" slot="reference" class="differValue">{{item.value}}</span>
                        </li>
                    </ul>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align: right">
                    <el-button el-button--primary type="primary"  @click="selectDiffer = false">返 回</el-button>
                </div>
            </el-dialog>
            <!--增删改差异-->
            <el-dialog id="operateDiffer"  :title="differTitle"  :visible.sync="showDiffer"  @close="closeDialogAddgsVisible()" width="540px" >
                <div  v-for="item1 in allMessages" :key="item1.diffBillNo" style="display: flex;flex-direction: row">
                    <ul  id="numList">
                        <li v-if="adapt"><span class="differTitle">差异单号:</span><span  v-if="adapt" style="width: 60%;text-align: left" class="differValue">{{item1.diffBillNo}}</span>
                            <span style="width: 85px;color: #008cff" v-if="!pullDown"  @click="setPullDown(true)">显示▼</span>
                            <span style="width: 85px;color: #008cff"  v-else @click="setPullDown(false)">收起▲ </span>
                        </li>
                        <li v-else> </li>
                        <li v-if="pullDown" ><span class="differTitle">对账单号:</span><span class="differValue">{{item1.statBillNo}}</span></li>
                        <li v-if="pullDown" ><span class="differTitle">运单号:</span><span class="differValue">{{item1.sourceBillNo}}</span></li>
                        <li  v-if="pullDown"><span v-if="adapt" class="differTitle">上报人:</span><span v-if="adapt" class="differValue">{{item1.createUserName}}</span></li>
                    </ul>
                </div>
                <el-form   >
                    <el-form-item label="差异类型:" >
                        <el-select  placeholder="请选择"  v-model="listOptionId" @change="selectOption()">
                            <el-option  v-for="item in optionList" :key="item.listName" :label="item.listName" :value="item.listValue"/>{{item.listName}}
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="差异说明:" >
                        <el-input   maxlength="50" v-model="msg.content" @keyup.native="detectContentup()"  resize="none" @keydown.native="detectContent()"  :autosize="{minRows:4,maxRows:4}" type="textarea"  placeholder="请输入实际货物信息或其他补充信息" style="width: 80%;"/><!-- v-text="form.originalDesc"    autosize   :autosize="{ minRows: 2, maxRows: 4}" -->
                        <p v-if="remainText"  style="margin-left: 90px;text-align: left;color: red">请输入差异原因</p>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer " :id="displayStyle===1?'addDisplay':'delDisplay'">
                    <template v-if="adapt">
                        <el-popover width="320" height="122"  v-model="visible_differ">
                            <div style="    padding: 10px;">
                                <p style="    margin-bottom: 20px;">删除标记运单，在账单确认前都可再次标记</p>
                                <div style="display: flex;justify-content:flex-end">
                                    <el-button   slot="reference" @click="visible_differ=false">暂不删除</el-button>
                                    <el-button type="primary"  @click="delDiffer"  slot="reference">确认删除</el-button>
                                </div>
                            </div>
                            <el-button id="isDel" slot="reference">删除</el-button>
                        </el-popover>
                    </template>
                    <div>
                        <el-button @click="showDiffer = false" style="margin-right: 12px">取 消</el-button>
                        <el-popover width="320" height="122"  v-model="visible_differ1"  v-if="adapt">
                            <div style=" padding: 10px;">
                                <p style=" margin-bottom: 20px;">是否确认修改</p>
                                <div style="display: flex;justify-content:flex-end">
                                    <el-button   slot="reference" @click="visible_differ1=false">取消</el-button>
                                    <el-button type="primary"  @click="saveDiffer()"   slot="reference">确认</el-button>
                                </div>
                            </div>
                            <el-button  slot="reference"   type="primary"  >{{differButton}}</el-button>
                        </el-popover>
                        <el-button v-else slot="reference"   type="primary" @click="saveDiffer()"  >{{differButton}}</el-button>

                    </div>
                </div>
            </el-dialog>
        </div>
    </div>


</template>

<script>

  import API from "../../../api/bill";

    const api = new API();
    const cityOptions = [
      "上报日期",
      "差异编号",
      "上报人",
      "对账单号",
      "账单创建日期",
      "运单号",
      "差异类型",
      "差异说明",
      "处理状态",
      "处理时间",
      "处理人",
      "处理说明",
  ];
    export default {
        name: "manageDiffer",
        data(){
                return{
                    differDate:[
                        {name:"差异标记日期",value:"1"},
                        {name:"差异标记日期",value:"2"},
                        {name:"差异标记日期",value:"3"},
                        {name:"差异标记日期",value:"4"},
                    ],
                    differNum:[

                        {name:"对账单号",value:"2"},
                        {name:"运单号",value:"3"},
                        {name:"差异单号",value:"1"},
                    ],
                    searchNum:{content:''},

                    differStatus:[
                        {name:"全部",value:""},
                        {name:"待处理",value:"unresolved"},
                        {name:"已办结",value:"resolved"},
                    ],

                    columnTitle : [
                        "上报日期",
                        "差异编号",
                        "上报人",
                        "对账单号",
                        "账单创建日期",
                        "运单号",
                        "差异类型",
                        "差异说明",
                        "处理状态",
                        "处理时间",
                        "处理人",
                        "处理说明",
                    ],
                    cities: cityOptions,
                    tableData:[ ],
                    totalNumber:11,
                    pagesize: 10,
                    currentPage: 1,
                    TableMaxHeight:window.screen.height-515,
                    TableMaxWidth:document.body.clientWidth,
                    deviceFormData:{
                        time:[]
                    },
                    item: {},
                    diffBillNos:'',//差异单号 英文逗号分割CY0000401210533
                    statBillNos:'',//对账单号 英文逗号分割
                    sourceBillNos:'',//运单号 英文逗号分割
                    statusList:'',
                    numList:'',
                    filtrate: false,


                    optionList:[
                        {listName:"非我司运单",listValue:"not_my_waybill"},
                        {listName:"运费有误",listValue:"freight"},
                        {listName:"产品类型有误",listValue:"product_type"},
                        {listName:"重量体积有误",listValue:"weight_volume"},
                        {listName:"保价有误",listValue:"valuation"},
                        {listName:"价格折扣有误",listValue:"price_discount"},
                        {listName:"此单已付款",listValue:"has_paid"},
                        {listName:"其他问题",listValue:"other"}
                    ],
                    allMessages:[//拿接口是拿sourceBillNo这个字段
                        {diffBillNo:"",statBillNo:"",sourceBillNo:"",createUserName:""},
                    ],
                    selectAllMessages:[
                        {differTitle:"差异单号:",value:"",color:""},
                        {differTitle:"对账单号:",value:"",color:""},
                        {differTitle:"运单号:",value:"",color:""},
                        {differTitle:"上报人:",value:"",color:""},
                        {differTitle:"差异类型:",value:"",color:""},
                        {differTitle:"差异说明:",value:"",color:""},
                        {differTitle:"办结人:",value:"",color:1},
                        {differTitle:"处理意见:",value:"",color:""}
                    ],
                    phoneNum:"",
                    delMessage:"",
                    addMessage:"",
                    sourceBillNo:'',//暂存,
                    orderNo:'',//暂存订单号
                    statBillNo:'',
                    differButton:'',
                    visible_differ:false,
                    visible_differ1:false,
                    cancelConfirmMessage:'',
                    sureConfirmMessage:'',
                    listOptionId:"",
                    remainText:false,//提示输入差异原因
                    displayStyle:1,//1新增 2修改删除 3查看完结
                    adapt:false,//区分新增和修改
                    addNew:true,
                    typeId:"success",
                    typeTitle:"标记成功",
                    differTitle:"差异标记",
                    selectDiffer:false,//显示隐藏完结差异框
                    showDiffer:false,//显示新增或修改框
                    pullDown: false,
                    msg:{content:""},
                    phoneNumDiffer:"",
                    pickerOptions:{
                        disabledDate: time => {
                            const day = 90 * 24 * 3600 * 1000 // 31536000000
                            // 返回小于当前日期并两个月内的日期
                            return time.getTime() > Date.now() || time.getTime() < (Date.now() - 8.64e7) - day
                        }
                    },
                    tableShow: false,
                    isIndeterminate: true,
                    checkAll: false, // 全选默认值
                    checkedCities: [
                        "上报日期",
                        "差异编号",
                        "上报人",
                        "对账单号",
                        "账单创建日期",
                        "运单号",
                        "差异类型",
                        "差异说明",
                        "处理状态",
                        "处理时间",
                        "处理人",
                        "处理说明",
                    ],
                    pointDecord:0,
                    hideNum:true,
                    searchNums:{mainContent:""},
                    secondBox:false,

                }
        },
        methods:{
            async getDiffers(){
                this.filtrate=false;
                this.searchNum.content="";
                this.searchNums.mainContent="";
                this.statusList="";
                this.numList="2";
                let parme = {
                    "diffBillNos": "",//差异单号 英文逗号分割CY0000401210533
                    "statBillNos": "",//对账单号 英文逗号分割
                    "sourceBillNos": "",//运单号 英文逗号分割
                    "diffStatus": "",//差异处理状态unresolved
                    "createTimeStart": this.deviceFormData.time[0],
                    "createTimeEnd":  this.deviceFormData.time[1],
                    "currentPage": this.currentPage,
                    "pageSize": this.pagesize,
                };
                let res = await api.getDiffersList(parme);
                if(res=="无差异数据"){
                    this.tableData=[];
                }else {

                    this.tableData = res.datalist;
                    this.totalNumber = res.total;

                    if(this.totalNumber!=0){
                        this.tableData.forEach((item) => {
                            if (item.diffStatus == "未处理") {
                                item.diffStatus = "未处理";
                            } else {
                                item.diffStatus = "已办结";
                            }
                            if( item.createTime!=""){
                                item.createTime = this.$moment(item.createTime).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                );
                            }

                            if( item.modifyTime!=""){
                                item.modifyTime = this.$moment(item.modifyTime).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                );
                            }

                        });

                    }
                }
            },

            async selectDifferByCon(){
                this.searchNums.mainContent=this.searchNum.content;
                let StrTemp=this.searchNum.content;
                StrTemp = StrTemp.replace(/\s*/g,'');
                this.pointDecord='';
                let decorList=StrTemp.split(',');
                if(decorList.length>10){
                    this.typeId="warning";
                    this.typeTitle="最多支持10个单号";
                    this.remain()
                }else{
                    this.filtrate=true;
                    let numListVal=document.getElementById("numListDiffer").value;
                    if(numListVal=="1"){
                        this.statBillNos=''
                        this.sourceBillNos='';
                        this.diffBillNos=this.searchNum.content;
                    }else if(numListVal=="2"){
                        this.diffBillNos=''
                        this.sourceBillNos='';
                        this.statBillNos=this.searchNum.content;
                    }else{
                        this.diffBillNos=''
                        this.statBillNos='';
                        this.sourceBillNos=this.searchNum.content;
                    }
                    let  parme = {
                           "diffBillNos": this.diffBillNos,//差异单号 英文逗号分割CY0000401210533
                           "statBillNos":  this.statBillNos,//对账单号 英文逗号分割
                           "sourceBillNos": this.sourceBillNos,//运单号 英文逗号分割
                           "diffStatus": document.getElementById("statusList").value,//差异处理状态unresolved
                           "createTimeStart": this.deviceFormData.time[0],
                           "createTimeEnd":  this.deviceFormData.time[1],
                            "currentPage": this.currentPage,
                            "pageSize": this.pagesize,
                       };
                    let res = await api.getDiffersList(parme);
                    if(res=="无差异数据"){
                        this.tableData=[];
                    }else{

                        this.tableData=res.datalist;
                        this.totalNumber = res.total;
                        if(this.totalNumber!=0) {
                            this.tableData.forEach((item) => {
                                if (item.billDiffStatus == "unresolved") {
                                    item.billDiffStatus = "已标记";
                                } else {
                                    item.billDiffStatus = "已完结";
                                }
                                if (item.createTime != "") {
                                    item.createTime = this.$moment(item.createTime).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                    );
                                }
                                if (item.modifyTime != "") {
                                    item.modifyTime = this.$moment(item.modifyTime).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                    );
                                }

                            });
                        }
                    }

                }
            },
                /* 设置默认时间
                */
            getInitialTime() {
              const that = this;
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 86400000 * 30);/* 86400000 * 30 ,3600 * 1000 *200 * 7*/
              that.deviceFormData.time[0] = that.formatDate(start);
              that.deviceFormData.time[1] = that.formatDate(end);
              that.getDiffers();
          },
          /**
           * 格式化时间
           */
          formatDate(date) {
              var myyear = date.getFullYear();
              var mymonth = date.getMonth() + 1;
              var myweekday = date.getDate();

              if (mymonth < 10) {
                  mymonth = "0" + mymonth;
              }
              if (myweekday < 10) {
                  myweekday = "0" + myweekday;
              }
              return myyear + "-" + mymonth + "-" + myweekday;
          },
            handleSizeChange(val) {
                this.pagesize = val;
                this.currentPage = 1; // 切换 没有多少条的时候 重置为第1页开始
                this.filtrate ?this.selectDifferByCon() : this.getDiffers() ;
                console.log(`每页 ${val} 条`);
            },
            // 分页 : 换页
            handleCurrentChange(val) {
                this.batchShow = true;
                this.currentPage = val;
                this.filtrate ?this.selectDifferByCon() : this.getDiffers() ;
                console.log(`当前页: ${val}`);
            },


            async selectBy(selectCurList) {

                this.batchShow = true;
                this.sourceBillNo=selectCurList.sourceBillNo;
                this.orderNo=selectCurList.orderNo;
                this.statBillNo=selectCurList.statBillNo;
              /*  if(selectCurList.diffStatus==" 标记 "){//显示新增框
                    this.allMessages[0].statBillNo= this.statBillNo;
                    this.allMessages[0].sourceBillNo= this.sourceBillNo;
                    this.pullDown=true;
                    this.differButton="保 存";
                    this.displayStyle=1;
                    this.showDiffer=true;
                    this.adapt=false;
                    this.addNew=true;
                    this.selectDiffer=false;
                }else*/ if(selectCurList.diffStatus=="未处理"){//显示修改框
                    this.selectDifferByNo()
                    this.differButton="修 改";
                    this.displayStyle=2;
                    this.showDiffer=true;
                    this.adapt=true;
                    this.addNew=false;
                    this.selectDiffer=false;
                }else{//显示查询框
                    this.selectOverList();
                    this.selectDiffer=true;
                    this.showDiffer=false;
                }
            },
            closeDialogAddgsVisible() {
                this.clearData();
                this.showDiffer=false;
                //this.$refs.addForm.resetFields();//element封装的方法,清空模态框的值
                this.differTitle = "差异标记" //初始化title的值
                this.addForm = {//初始化addForm中的值
                    name: "",
                    sort: "",
                }

            },
            async clearData(){//取消或者叉掉后清空文本
                this.remainText=false;
                this.msg.content="";
                this.listOptionId='';

            },
            setPullDown (data) {
                this.pullDown = data
            },
            async remain() {
                this.$message({
                    message:this.typeTitle,
                    type: this.typeId,//error info warning
                });
            },
            async delDiffer(){//删除
                let parme = {
                    "diffBillNo": this.allMessages[0].diffBillNo
                };
                let res = await api.deleteDiffer(parme);
                console.info(res)
                if(res=="删除差异成功"){
                    this.typeId="success";
                    this.typeTitle="差异标记已删除";
                }else{
                    this.typeId="error";
                    this.typeTitle="差异标记删除失败";
                }
                this.remain()
                this.closeDialogAddgsVisible()
                this.visible_differ=false
                this.filtrate ?this.selectDifferByCon() : this.getDiffers() ;

            },
            async confirmAdd(){
                let obj = {};//定义对象集合
                obj = this.optionList.find(item => {//projectlist 为Select遍历集合 project 为Select 遍历 对象
                    return item.listValue === this.listOptionId; //筛选出匹配数据 返回对象
                });
                if(this.msg.content==""){
                    this.msg.content=obj.listName;
                }
                let parme = {
                    "statBillNo":this.statBillNo,
                    "orderNo":this.orderNo,
                    "sourceBillNo":this.sourceBillNo,
                    "diffType": this.listOptionId,
                    "diffDescription":this.msg.content
                };
                let res = await api.addDiffer(parme);
                console.info(res)

                if(res=="新增差异成功"){
                    this.typeId="success";
                    this.typeTitle="差异标记成功";
                }else{
                    this.typeId="error";
                    this.typeTitle="差异标记失败";
                }
                this.remain()
                this.closeDialogAddgsVisible()
                this.filtrate ?this.selectDifferByCon() : this.getDiffers() ;

            },

            async confirmUpdate(){
                let obj = {};//定义对象集合
                obj = this.optionList.find(item => {//projectlist 为Select遍历集合 project 为Select 遍历 对象
                    return item.listValue === this.listOptionId; //筛选出匹配数据 返回对象
                });
                // let description='';
                if(this.msg.content=="") {
                    this.msg.content = obj.listName;
                }
                let parme = {
                    "diffBillNo": this.allMessages[0].diffBillNo,
                    "diffType": this.listOptionId,
                    "diffDescription": this.msg.content
                }
                let res = await api.updateDiffer(parme);
                console.info(res)
                if (res == "修改差异成功") {
                    this.typeId = "success";
                    this.typeTitle = "修改差异成功";
                } else {
                    this.typeId = "error";
                    this.typeTitle = "修改差异失败";
                }
                this.remain()
                this.closeDialogAddgsVisible()
                this.visible_differ1=false;
                this.filtrate ?this.selectDifferByCon() : this.getDiffers() ;
            },

            async isUpdate() {
                let parme = {
                    "statBillNo": this.statBillNo,
                    "orderNo": this.orderNo,
                };
                let res = await api.selectDifferlist(parme);
                if (this.allMessages[0].diffBillNo == res.diffBillNo && this.listOptionId == res.diffType && this.msg.content == res.diffDescription) {
                    this.typeId = "info";
                    this.typeTitle = " 请先修改数据再提交！";
                    this.remain()
                } else {
                    this.confirmUpdate()
                }
            },
            async getPhoneNum(){
                let parme = {
                    "diffBillNo": this.selectAllMessages[0].value
                };
                let res = await api.phone(parme);
                if(res==95353){
                    this.phoneNum="暂未查询到该人员手机号，请联系95353！";
                }else{
                    this.phoneNum="联系方式:"+res;
                }
            },
            async selectDifferByNo(){
                let parme = {
                    "statBillNo":this.statBillNo,
                    "orderNo":this.orderNo,
                };

                let res = await api.selectDifferlist(parme);
                console.info(this.statBillNo)
                this.listOptionId=res.diffType;
                this.allMessages[0].diffBillNo=res.diffBillNo;
                this.allMessages[0].statBillNo=res.statBillNo;
                this.allMessages[0].sourceBillNo=res.sourceBillNo;
                this.allMessages[0].createUserName=res.createUserName;
                this.msg.content=res.diffDescription;

            },


            async selectOverList(){
                let parme = {
                    "statBillNo":this.statBillNo,
                    "orderNo":this.orderNo,
                };
                let res = await api.selectDifferlist(parme);
                let obj = {};//定义对象集合
                obj = this.optionList.find(item => {
                    return item.listValue === res.diffType;
                });
                this.selectAllMessages[0].value=res.diffBillNo;
                this.selectAllMessages[1].value=res.statBillNo;
                this.selectAllMessages[2].value=res.sourceBillNo;
                this.selectAllMessages[3].value=res.createUserName;
                this.selectAllMessages[4].value=obj.listName;
                this.selectAllMessages[5].value=res.diffDescription;
                this.selectAllMessages[6].value=res.currentHandlerName;
                this.selectAllMessages[7].value=res.finishDescription;
                this.getPhoneNum();
            },

            addOrAdapt(){
                if(this.differButton=="保 存"){
                    this.confirmAdd()
                }else if(this.differButton=="修 改"){
                    this.isUpdate()
                }
            },

            async saveDiffer(){//新增或者编辑
                if( this.listOptionId!=""){
                    this.remainText=false;
                    if(this.listOptionId=="other"){
                        if(this.msg.content==""){
                            this.remainText=true;
                            return;
                        }else{
                            this.addOrAdapt();
                        }
                    }else{
                        this.addOrAdapt();
                    }
                }else{
                    this.typeId="warning";
                    this.typeTitle="请您先选择差异类型，然后再确认！";
                    this.remain()
                }
            },
            async detectContentup(){//等检测松开按钮文本框是否为空
                if(this.msg.content==""){
                    if(this.listOptionId=="other"){
                        this.remainText=true;
                    }
                }else{
                    this.remainText=false;
                }

            },
            async detectContent(){//检测文本框内容长度

                if(this.msg.content.length==50){
                    this.typeId="info";
                    this.typeTitle="最大输入50个字符";
                    this.remain()
                    // this.msg.content =this.msg.content.substr(0, 49)
                }

            },
          async  showNum(diffBillNo){
                let parme = {
                    "diffBillNo": diffBillNo
                };
                let res = await api.phone(parme);
              if(res==95353){
                    this.phoneNumDiffer="暂未查询到改人员手机号，请联系95353!";
                }else{
                    this.phoneNumDiffer="联系方式:"+res;
                }
            },
            selectOption(){//当选择其他的时候，显示提示
                //  event.target.listName;
                if(this.listOptionId=="other"){
                    if(this.msg.content==""){
                        this.remainText=true;
                    }
                }else{
                    this.remainText=false;
                }
            },
            titShow() {
                //弹出配置表头
                this.tableShow = !this.tableShow;
            },
            removeAll(e) {
             if(e.target.id!="secondBox"){
                 this.hideNum=true;
                 this.secondBox=false;
              }else{
                 this.secondBox=true;
             }

                this.tableShow = false; // 点击空白 隐藏配置表头
            },
            handleCheckedCitiesChange(val) {
                //配置表头单个勾选
                let checkedCount = val.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate =
                    checkedCount > 0 && checkedCount < this.cities.length;
            },
            handleCheckAllChange(val) {
                //配置表头全选功能
                this.checkedCities = cityOptions;
                this.isIndeterminate = false;
                if (!val) {
                    this.columnTitle = [
                        "上报日期",
                        "差异编号",
                        "上报人",
                        "对账单号",
                        "账单创建日期",
                        "运单号",
                        "差异类型",
                        "差异说明",
                        "处理状态",
                        "处理时间",
                        "处理人",
                        "处理说明",
                    ];
                }
            },
            detectSpe(){
                let StrTemp=this.searchNum.content;
                StrTemp=StrTemp.replace(/\s*/g,'');
                this.pointDecord='';
                let decorList=StrTemp.split(',');
                if(decorList.length==10){
                    for(let i=0;i<10;i++){
                        if(i==9){
                            this.pointDecord+=decorList[i];
                        }else{
                            this.pointDecord+=decorList[i]+",";
                        }
                    }
                    this.searchNum.content=this.pointDecord;
                    this.typeId="warning";
                    this.typeTitle="最多支持10个单号";
                    this.remain()
                }else if(decorList.length>10){
                    for(let i=0;i<10;i++){
                        if(i==9){
                            this.pointDecord+=decorList[i];
                        }else{
                            this.pointDecord+=decorList[i]+",";
                        }
                    }
                    this.searchNum.content=this.pointDecord;
                    this.typeId="warning";
                    this.typeTitle="最多支持10个单号";
                    this.remain()
                }

            },
            showArea(){
              this.hideNum=false;
              this.secondBox=true;
                this.$refs.blurLevea.focus()
                this.searchNum.content= this.searchNums.mainContent;

               // this.searchNums.mainContent=this.searchNum.content;
            },
            inputShowArea(){//除空格
                this.searchNums.mainContent= this.searchNums.mainContent.replace(/\s*/g,'');
                this.searchNum.content= this.searchNums.mainContent;
            },
            showNumBox(){
                this.hideNum=false;
                this.$refs.blurLevea.focus()
            },
            getSecondVal(){//将文字域的值给到文本框
              if(this.searchNum.content!=""){
                  this.searchNum.content= this.searchNum.content.replace(/\s*/g,'');
                 let temporary = this.searchNum.content.split("\n");
                 this.searchNum.content=temporary.join();
                  this.searchNums.mainContent=this.searchNum.content;
              }
            },
            delStrim(){//去掉输入的空格
                if(this.searchNum.content!=""){
                    let clearTemp=this.searchNum.content;
                    this.searchNum.content=clearTemp.replace(/\s*/g,'');
                }

            },
            firstGetDiffer(){
                this.currentPage=1;
                this.pageSize=10
                this.getDiffers()
            },
            firstSelectByCon(){
              this.currentPage=1;
              this.pageSize=10
                this.selectDifferByCon()

            }
        },
        created() {
            const that = this;
            that.TableMaxHeight=window.screen.height-515;
            that.TableMaxWidth=document.body.clientWidth;
            that.getInitialTime();
            this.checkedCitiesDisable = JSON.parse(JSON.stringify(this.columnTitle));
            document.addEventListener('click',(e)=>{
                if(e.target.classname=="hideNum"){
                        this.hideNum = true;
                }
            })

        },
       mounted() {
           window.addEventListener('resize', function() {

               this.TableMaxWidth=document.body.clientWidth;
           })
       }
    };

</script>

<style scoped>
    .list{padding: 6px; margin-right: 8px; text-align: center; height: 32px; border: 1px solid #dcdfe6;}
    >>> .el-input__inner{height: 32px;padding: 5px}
    .el-range-editor--mini.el-input__inner{height: 32px;padding: 5px}
    #content{width: 100%;border: 1px solid #ECECEC;margin-top: 17px;}
    #bottom{    text-align: left;}
    .statusCss {background: #FBE4E4; color: red; border-radius: 20px;    border-radius: 83px; padding: 7px;}
    .el-select{width: 80%; }
    .el-dialog li{ list-style: none; }
    #numList li,#selectNumList li{display: flex;flex-direction: row;width: 100%;margin-bottom:24px;}
    #selectNumList .differTitle{width: 100px;text-align: left}
    #numList{    margin-bottom: 20px;}
    #numList,#selectNumList{    width: 100%;}
    #numList .differValue{width: 80%;text-align: left;padding-left: 30px;}
    .differTitle{width:  61px;    text-align: right;}
    .blue{color:#008cff}
    .black{color: #645556}
    #addDisplay{display: flex;justify-content: flex-end}
    #delDisplay{display: flex;justify-content: space-between}
    #isDel{border: none;color: red;background: white}
    #isDel:hover{color: red;background: white}
    #delDisplay ，addDisplay .el-button{margin-right: 12px}
    .titName { height: 242px;width: 234px;border-radius: 4px;border: 1px solid #ccc; position: absolute;top: 26px; left: 24px; z-index: 1011; background-color: #fff;
        padding: 8px;
        overflow: auto;
 }
   >>>.tableTiele .el-checkbox-group {  overflow: auto;display: flex;flex-direction: column }
    #content.el-table__header{max-width: calc(100vh - 40px)}
    .differNum,.differStatus,.differDate,.el-buttons{ display: flex; flex-direction: row;white-space:nowrap;line-height: 36px;}




</style>